import { render } from "./infocarGraficheAccordion.vue?vue&type=template&id=65cbe61a&scoped=true"
import script from "./infocarGraficheAccordion.vue?vue&type=script&lang=js"
export * from "./infocarGraficheAccordion.vue?vue&type=script&lang=js"

import "./infocarGraficheAccordion.vue?vue&type=style&index=0&id=65cbe61a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cbe61a"]])

export default __exports__